import { useLocation } from 'react-router-dom';

export const useIsHomePage = () => {
    const { pathname } = useLocation();
    const homePathnames = ['/', '/home', '/home/', '/elcid', '/elcid/'];

    const isHomePage = homePathnames?.includes(pathname);

    return { isHomePage };
};